import "../css/comments.css";
import React, {useState} from "react";
import {BASE_URL} from "../constants";
import { useLanguage } from "../components/Language.js";

function CommentForm({type, event_id, locationName, comments, fetchComments}) {

    const [imageFile, setImageFile] = useState(null);
    const [videoFile, setVideoFile] = useState(null);
    let isSignedIn = (sessionStorage.getItem("USER") === null ? false : true);
    const {language} = useLanguage();

    // const checkSignedIn = async() => {
    //     let username = (sessionStorage.getItem("USER") === null ? null : JSON.parse(sessionStorage.getItem("USER"))['username']);
    //     if (username === null){
    //         return false;
    //     }else{
    //         return true;
    //     }
    // }

    const translations = {
        en: {
            youNeedToSignInToPostAComment: "You need to sign in to post a comment.",
            pleaseEnterYourComment: "Please enter your comment",
            uploadAnImage: "Upload An Image",
            uploadAVideo: "Upload An Video",
            addComment: "Add Comment",    
        },

        gd: {
          youNeedToSignInToPostAComment: "Feumaidh tu soidhneadh a-steach gus abairt a sgrìobhadh",
          pleaseEnterYourComment: "Cuir a-steach d' abairt",
          uploadAnImage: "Luchdaich suas ìomhaigh",
          uploadAVideo: "Luchdaich suas bhidio",
          addComment: "Sgrìobh beachd",
            
        },
    };

    const [formData, setFormData] = useState({
        content: "", 
        comment_image: "",
        comment_video: ""
    });

    const handleInputChange = (e) => {
        const {name, value} = e.target;
        console.log(name);
        console.log(value);
        setFormData({ ...formData, [name]: value});
    };


    const handleCommentSubmit = async (e) => {
        e.preventDefault();
        fetchComments();

        let requestBody = { 
            content: formData.content,
            author: JSON.parse(sessionStorage.getItem("USER")),
        };

        if (type === "event") {
            requestBody.event_id = event_id;
        }
        else if (type === "location"){
            requestBody.locationName = locationName;
        }

        console.log("Request body for comment submission:", requestBody);

        let response = await fetch(`${BASE_URL}/api/save_comment/`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },

        body: JSON.stringify(requestBody),

        });

        let data = await response.json(); 

        if (response.ok) {

            const comment_id = data["comment_id"];
            const mediaData = new FormData();

            if (imageFile === null){
                mediaData.append('picture', null);
            }else {
                mediaData.append('picture', imageFile);
            }

            if (videoFile === null){
                mediaData.append('video', null);
            }else {
                mediaData.append('video', videoFile);
            }

            mediaData.append('comment_id', comment_id);

            try {
                await fetch(`${BASE_URL}/api/save_comment_media/`, {
                    method: "POST",
                    body: mediaData,
                });

            }catch (error) {
                console.error("Unable to save media");
            }

        }


        setFormData({
            content: "", 
            comment_image: "",
            comment_video: ""
        });

        setImageFile(null);
        setVideoFile(null);
        alert(data.message);
        fetchComments();

    };
       


    const handleImageChange = async(e) => {
        const file = e.target.files[0];
        if (file) {
            setImageFile(file);
            handleInputChange(e);
        }else{
            setImageFile(null);
            handleInputChange(e);
        }
    }

    const handleVideoChange = async(e) => {
        const file = e.target.files[0];
        if (file) {
            setVideoFile(file);
            handleInputChange(e);
        }else{
            setVideoFile(null);
            handleInputChange(e);
        }
    }


    return (

        <div className="create-comment">
            {!(isSignedIn) && (
                <p className="sign-in-prompt"> {translations[language].youNeedToSignInToPostAComment}</p>
            )}

            {(isSignedIn) && (

                <form id="comment-form" onSubmit={handleCommentSubmit}>

                <textarea
                    id = "comment-content"
                    rows="3"
                    type="textarea"
                    name="content"
                    value={formData.content}
                    onChange={handleInputChange}
                    placeholder={translations[language].pleaseEnterYourComment}
                    required
                />
                
                <div className="media-input">
                
                    <label className="upload-file" for="comment-img"> {translations[language].uploadAnImage} </label>
                    <input
                        type="file"
                        id = "comment-img"
                        name="comment_image"
                        value={formData.comment_image}
                        onChange={handleImageChange}
                        accept="image/*"
                    />
                    
                    <label className="upload-file" for="comment-video"> {translations[language].uploadAVideo}</label>
                    <input
                        type="file"
                        id = "comment-video"
                        name="comment_video"
                        value={formData.comment_video}
                        onChange={handleVideoChange}
                        accept="video/*"
                    />
                </div>


                <button type="submit" className = "submit-comment">{translations[language].addComment}</button>


                </form>
            )}

        </div>

    );  

}

export default CommentForm